import { useState, useEffect } from "react"
import { MdClose } from "react-icons/md"
import { FaRegCheckSquare, FaRegPlusSquare } from "react-icons/fa"
import { CircularProgress } from "@mui/material"
import tw from "tailwind-styled-components"
import { ModalHeader, ScrollableContent } from "../Styles/InputStyles"
import axios from "axios"
import { useQuery } from "react-query"
import Config from "../../Config"
import { useSelector } from "react-redux"

const AssignStaff = ({ assignStaffMutate, selectedData, setIsAssignStaff, isAssignStaff, assignStaffLoading }) => {
    const leadId = selectedData?.id
    const user = useSelector((state) => state.UserReducer.user)
    const fetchListing = async () =>
        await axios.get(`${Config.apiUrl}/lead/linked/staff/${leadId}`, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${user.token}`,
            },
        })

    const { isLoading, error, data, refetch, isRefetching } = useQuery(["propertyData", leadId], fetchListing, {
        enabled: Boolean(isAssignStaff && leadId),
    })

    const staff = data?.data?.data
    const [linkedStaffs, setLinkedStaffs] = useState([])
    const [isApiInProgress, setIsApiInProgress] = useState(false)

    useEffect(() => {
        if (staff && Array.isArray(staff)) {
            setLinkedStaffs(staff)
        }
    }, [staff])

    const handleToggle = (staffId, isLinked) => {
        if (isApiInProgress || assignStaffLoading) return

        setIsApiInProgress(true)
        setLinkedStaffs((prev) => prev.map((prop) => (prop.id === staffId ? { ...prop, isLoading: true } : prop)))

        assignStaffMutate(
            {
                leadId: selectedData?.id,
                toggleValue: isLinked ? 0 : 1,
                staffId: staffId,
            },
            {
                onSuccess: () => {
                    setLinkedStaffs((prev) =>
                        prev.map((prop) => (prop.id === staffId ? { ...prop, isLinked: !isLinked, isLoading: false } : prop)),
                    )
                    setIsApiInProgress(false)
                },
                onError: () => {
                    setLinkedStaffs((prev) => prev.map((prop) => (prop.id === staffId ? { ...prop, isLoading: false } : prop)))
                    setIsApiInProgress(false)
                },
            },
        )
    }

    return (
        <Container>
            <ModalHeader>
                <h1 className="text-white text-lg font-medium">Manage Linked Staffs</h1>
                <button onClick={() => setIsAssignStaff(false)}>
                    <MdClose color="white" size={24} />
                </button>
            </ModalHeader>

            {(isLoading || isRefetching || (!staff && isAssignStaff)) && (
                <div className="flex justify-center items-center my-40">
                    <CircularProgress size={40} />
                </div>
            )}

            {!isLoading && !isRefetching && linkedStaffs.length > 0 && (
                <ScrollableContent className="max-h-screen overflow-y-auto px-6 py-4">
                    {linkedStaffs.map((prop) => (
                        <PropertyRow key={prop.id}>
                            <Label>{prop.name}</Label>
                            <button
                                onClick={() => handleToggle(prop.id, prop.isLinked)}
                                disabled={prop.isLoading || isApiInProgress}
                            >
                                {prop.isLoading ? (
                                    <CircularProgress size={20} />
                                ) : prop.isLinked ? (
                                    <FaRegCheckSquare size={20} className="text-green-500 font-normal text-sm" />
                                ) : (
                                    <FaRegPlusSquare size={20} className="text-gray-400 font-normal text-sm" />
                                )}
                            </button>
                        </PropertyRow>
                    ))}
                </ScrollableContent>
            )}

            {!isLoading && !isRefetching && staff && linkedStaffs.length === 0 && (
                <div className="flex justify-center items-center my-20">
                    <p className="text-gray-500">No staff members found</p>
                </div>
            )}
        </Container>
    )
}

const Container = tw.div`bg-white w-full h-full flex flex-col`
const Header = tw.div`flex items-center justify-between bg-primary-color py-4 px-4`
const PropertyRow = tw.div`flex items-center justify-between py-3 border-b`
const Label = tw.span`text-gray-900`

export default AssignStaff
